import React from 'react';

export default function HomeCircle() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z'
        fill='#27272A'
      />
      <path
        d='M14 22.6666V15.9999H18V22.6666M10 13.9999L16 9.33325L22 13.9999V21.3333C22 21.6869 21.8595 22.026 21.6095 22.2761C21.3594 22.5261 21.0203 22.6666 20.6667 22.6666H11.3333C10.9797 22.6666 10.6406 22.5261 10.3905 22.2761C10.1405 22.026 10 21.6869 10 21.3333V13.9999Z'
        stroke='#A1A1AA'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
